import { gql } from "@apollo/client";

/**
 * IoT attach gate of a system (IBM-1039) — same contract as
 * `AssetLocationIotGate`; inside a gateway system the connection sits on the
 * system, so this flag (not the assets') decides. Only sent while
 * REACT_APP_ENABLE_SLA is on.
 */
export const SystemIotGate = gql`
    query SystemIotGate($id: ID!) {
        system(id: $id) {
            id
            canAttachIotConnection
            effectiveNetworkScan {
                state
                scanDate
                source {
                    installedBaseNodeId
                    nodeTypeKey
                    name
                }
            }
            installedBaseNode {
                id
                pathNodes {
                    id
                }
            }
        }
    }
`;
